var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:{ highlight: _vm.highlight }},[(_vm.date)?_c('div',{staticClass:"service-date"},[(_vm.dateClass === 'expired')?_c('span',[_vm._v("⚠️")]):_vm._e(),_c('p',{staticClass:"date",class:_vm.dateClass},[_vm._v(_vm._s(_vm.date))])]):[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.content))]})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }